import { connect } from 'react-redux'
import ServiceCreateBottomBar from '../../components/services/edit/ServiceCreateBottomBar'
import { actionCreators } from '../../state/actions/services/index'
import { getService } from '../../state/reducers/services'
import { IServiceEditStep, IServiceEditStepData, IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  const serviceId = state.service.metadata.edit.serviceId
  let serviceName = ''
  if (serviceId) {
    const service = getService(state, serviceId)
    serviceName = service.name
  }
  return {
    serviceName,
    steps: state.serviceEdit.steps.list,
    currentStep: state.serviceEdit.steps.currentStep,
    onNextClick: ownProps.onNextClick
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onPreviousClick: (steps: IServiceEditStep[], currentStep: IServiceEditStepData) => {
      dispatch(
        actionCreators.serviceCreateSetCurrentStep({
          position: --currentStep.position,
          fetching: false,
          fetchingError: '',
          updating: false,
          updatingError: '',
          changed: false
        })
      )
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceCreateBottomBar)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceCreateBottomBar.ts